import React, { useState } from 'react';





const EscalationTable = ({ escalations }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterReason, setFilterReason] = useState('all');
  const [filterTier, setFilterTier] = useState('all');
  const [filterOutcome, setFilterOutcome] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const reasonOptions = [
  { value: 'all', label: 'All Reasons' },
  { value: 'technical', label: 'Technical Issue' },
  { value: 'billing', label: 'Billing Dispute' },
  { value: 'complex', label: 'Complex Inquiry' },
  { value: 'escalation', label: 'Customer Request' }];


  const tierOptions = [
  { value: 'all', label: 'All Tiers' },
  { value: 'premium', label: 'Premium' },
  { value: 'standard', label: 'Standard' },
  { value: 'basic', label: 'Basic' }];


  const outcomeOptions = [
  { value: 'all', label: 'All Outcomes' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'pending', label: 'Pending' },
  { value: 'escalated', label: 'Re-escalated' }];


  const filteredEscalations = escalations?.filter((escalation) => {
    const matchesSearch = escalation?.customerName?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
    escalation?.caseId?.toLowerCase()?.includes(searchTerm?.toLowerCase());
    const matchesReason = filterReason === 'all' || escalation?.reason?.toLowerCase()?.includes(filterReason);
    const matchesTier = filterTier === 'all' || escalation?.customerTier?.toLowerCase() === filterTier;
    const matchesOutcome = filterOutcome === 'all' || escalation?.outcome?.toLowerCase() === filterOutcome;

    return matchesSearch && matchesReason && matchesTier && matchesOutcome;
  });

  const totalPages = Math.ceil(filteredEscalations?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedEscalations = filteredEscalations?.slice(startIndex, startIndex + itemsPerPage);

  const getOutcomeColor = (outcome) => {
    const colors = {
      'Resolved': 'bg-success text-success-foreground',
      'Pending': 'bg-warning text-warning-foreground',
      'Re-escalated': 'bg-error text-error-foreground'
    };
    return colors?.[outcome] || 'bg-muted text-muted-foreground';
  };

  const getTierBadge = (tier) => {
    const badges = {
      'Premium': 'bg-accent text-accent-foreground',
      'Standard': 'bg-secondary text-secondary-foreground',
      'Basic': 'bg-muted text-muted-foreground'
    };
    return badges?.[tier] || 'bg-muted text-muted-foreground';
  };

  return;
































































































































};

export default EscalationTable;